var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":""}},[(_vm.content.title!='')?_c('div',{staticClass:"headline mb-4"},[_vm._v(_vm._s(_vm.content.title))]):_vm._e(),_c('div',{staticClass:"course__text",domProps:{"innerHTML":_vm._s(_vm.content.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }